import AccountCreation, { Social } from "@/components/signup/account-creation";
import { SocialProvider } from "@/components/signup/utils";

export type UniformSignUpProps = {
    socialProviders?: SocialProvider[];
};

export const transformProviders = (providerList: string[]) => {
    return providerList.reduce(
        (previous, key) => ({ ...previous, [key.toLowerCase()]: key }),
        {}
    );
};

const UniformSignUpForm = ({ socialProviders }: UniformSignUpProps) => {
    return (
        <AccountCreation
            Login={null}
            Social={
                socialProviders?.length ? (
                    <Social providers={transformProviders(socialProviders)} />
                ) : undefined
            }
        />
    );
};

export default UniformSignUpForm;
